export function batteryIcon(voltage: number | undefined, lowThreshold: number, midThreshold: number) {
  if (voltage == undefined) {
    return 'fa-solid fa-battery-empty';
  } else if (voltage <= lowThreshold) {
    return 'fa-solid fa-battery-quarter';
  } else if (voltage <= midThreshold) {
    return 'fa-solid fa-battery-half';
  } else {
    return 'fa-solid fa-battery-full';
  }
}

export function batteryLevelColor(voltage: number | undefined, lowThreshold: number, midThreshold: number) {
  if (voltage == undefined) {
    return 'color-primary-information';
  } else if (voltage <= lowThreshold) {
    return 'color-danger';
  } else if (voltage <= midThreshold) {
    return 'color-warning';
  } else {
    return 'color-nominal';
  }
}
